import React, { Component } from "react";
import "./Header.scss";
import logo from "./logo.png";

const goTo = (id: any) => {
  const element = document.querySelector("#" + id);

  if (element) {
    const topPos = element.getBoundingClientRect().top + window.pageYOffset;

    window.scrollTo({
      top: topPos,
      behavior: "smooth",
    });
  }
};

class Header extends Component {
  render() {
    return (
      <div className="header">
        <div className="content">
          <div className="logo-area">
            <img className="logo" src={logo} alt="Logo" />
          </div>
          <div className="menu-area">
            <a
              href="#benefits"
              className="menu-item"
              onClick={() => goTo("benefits")}
            >
              Benefícios
            </a>
            <a href="#flow" className="menu-item" onClick={() => goTo("flow")}>
              Funcionamento
            </a>
            <a href="#diff" className="menu-item" onClick={() => goTo("diff")}>
              Diferenciais
            </a>
            <a href="#team" className="menu-item" onClick={() => goTo("team")}>
              Nossa equipe
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;
